export const dataHooks = {
  heading: 'heading',
  renamingField: 'renaming-field',
  input: 'editable-title-input',
};
